// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import FullSearchTsx from "./FullSearch.tsx";
import * as FullSearchTsx$1 from "./FullSearch.tsx";
import Close from "@mui/icons-material/Close";

function decodeFilter(jsf) {
  var match = jsf.typ;
  switch (match) {
    case "a" :
        return {
                TAG: /* Augment */3,
                _0: jsf.id
              };
    case "i" :
        return {
                TAG: /* Item */2,
                _0: jsf.id
              };
    case "p" :
        return {
                TAG: /* Places */4,
                _0: jsf.id,
                _1: Belt_Option.getExn(jsf.places)
              };
    case "t" :
        return {
                TAG: /* Trait */1,
                _0: jsf.id,
                _1: Belt_Option.getExn(jsf.rank)
              };
    case "u" :
        return {
                TAG: /* Unit */0,
                _0: jsf.id
              };
    default:
      throw {
            RE_EXN_ID: "Assert_failure",
            _1: [
              "FullSearch.res",
              20,
              9
            ],
            Error: new Error()
          };
  }
}

function encodeFilter(f) {
  switch (f.TAG | 0) {
    case /* Unit */0 :
        return {
                typ: "u",
                id: f._0,
                rank: undefined,
                places: undefined
              };
    case /* Trait */1 :
        return {
                typ: "t",
                id: f._0,
                rank: f._1,
                places: undefined
              };
    case /* Item */2 :
        return {
                typ: "i",
                id: f._0,
                rank: undefined,
                places: undefined
              };
    case /* Augment */3 :
        return {
                typ: "a",
                id: f._0,
                rank: undefined,
                places: undefined
              };
    case /* Places */4 :
        return {
                typ: "p",
                id: f._0,
                rank: undefined,
                places: f._1
              };
    
  }
}

var getPlayerOptions = FullSearchTsx$1.getPlayerOptions;

var getCompsOptions = FullSearchTsx$1.getCompsOptions;

var make = FullSearchTsx;

function FullSearch$FilterWrap(Props) {
  var children = Props.children;
  var onClick = Props.onClick;
  return React.createElement("div", {
              className: "relative p-[2px] cursor-pointer"
            }, children, React.createElement("div", {
                  className: "absolute left-0 top-0 right-0 bottom-0 rounded opacity-0 hover:opacity-100 bg-[#44444488] cursor-pointer z-10 flex items-center justify-center transition",
                  onClick: onClick
                }, React.createElement(Close, {
                      fontSize: "small"
                    })));
}

var FilterWrap = {
  make: FullSearch$FilterWrap
};

export {
  decodeFilter ,
  encodeFilter ,
  getPlayerOptions ,
  getCompsOptions ,
  make ,
  FilterWrap ,
  
}
/* getPlayerOptions Not a pure module */
